import React, { Component } from 'react'
import { connect } from 'react-redux'

import NewServiceSideSteps from 'components/organisms/big_steps_new_service'
import { NEW_SERVICE_VIEWS } from 'constants/index'
import Name from './name'
import Description from './description'
import Cost from './cost'
import Zones from './zones'
import Availabiity from './availability'
import Photos from './photos'
import Video from './video'
import Types from './types'
import Includes from './includes'
import Category from './category'

class CreateService extends Component{

    render(){
        return(
            <>
                <div className='p-4'>
                    <h2 className='text-primary'> Nuevo Servicio</h2>
                </div>
                <section className='row no-gutters'>
                    <div className='col-3 d-flex flex-column'>
                        <NewServiceSideSteps/>
                    </div>
                    <div className='col-9 px-4'>
                        {this.props.newServiceStep ===  NEW_SERVICE_VIEWS.name && <Name/>}
                        {this.props.newServiceStep ===  NEW_SERVICE_VIEWS.description && <Description/>}
                        {this.props.newServiceStep ===  NEW_SERVICE_VIEWS.cost && <Cost/>}
                        {this.props.newServiceStep ===  NEW_SERVICE_VIEWS.zones && <Zones/>}
                        {this.props.newServiceStep ===  NEW_SERVICE_VIEWS.availability && <Availabiity/>}
                        {this.props.newServiceStep ===  NEW_SERVICE_VIEWS.photos && <Photos/>}
                        {this.props.newServiceStep ===  NEW_SERVICE_VIEWS.video && <Video/>}
                        {this.props.newServiceStep ===  NEW_SERVICE_VIEWS.types && <Types/>}
                        {this.props.newServiceStep ===  NEW_SERVICE_VIEWS.includes && <Includes/>}
                        {this.props.newServiceStep ===  NEW_SERVICE_VIEWS.category && <Category/>}
                    </div>
                </section>
            </>
        )
    }
}

function mapStateToProps({ shared }){
    const { newServiceStep } = shared
    return { newServiceStep }
}

export default connect(
    mapStateToProps,
    {}
)(CreateService)